<template>
  <section class="content">
    <div class="outer">
      <div class="jumbotron">
        <center>
          <img class="img-fluid" src="/img/cinegest.png" />
          <p>Version {{$store.state.version}}</p>
        </center>
        <h2>Connexion</h2>
        <div class="card-body">
          <div class="row">
            <div class="col-12">
              <form action id="authentication" method="post" class="login_validator">
                <div class="form-group">
                  <label for="username">Nom d'utilisateur</label>
                  <input
                    type="text"
                    class="form-control"
                    id="username"
                    name="username"
                    v-model="username"
                  />
                </div>
                <div class="form-group">
                  <label for="password">Mot de passe</label>
                  <input
                    type="password"
                    class="form-control"
                    id="password"
                    name="password"
                    v-model="password"
                  />
                </div>
                <div class="form-group">
                  <button @click.prevent="_login()" class="btn btn-primary btn-block">Se connecter</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- /.inner -->
    <!-- /#right -->
    <div class="background-overlay"></div>
  </section>
  <!-- Création de playtime -->
</template>

<script>
import api from "@/api";
import Vue from "vue";
import Swal from "sweetalert2";
import utils from "@/utils";
import { login } from "../auth";

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000
});

export default {
  data() {
    return {
      username: "",
      password: ""
    };
  },
  methods: {
    async _login() {
      let res = await api.login(this.username, this.password);
      Toast.fire({
        type: res.code === 200 ? "success" : "error",
        title: res.message
      });
      if (res.data && res.data.token) {
        if (res.data.admin) {
          login(res.data.token);
        } else {
          Toast.fire({
            type: "error",
            title: "Vous n'avez pas accès à cette application."
          });
        }
      }
    }
  }
};
</script>

